let config={
    appName:'',
    resPre:'https://'+location.hostname+':8081',
    skin:'teal',
    isDev:false,
    vaptchaId:'5de798b3e62d2b442088be96',//vaptcha的id
    officePre:'https://view.officeapps.live.com/op/view.aspx',
    resIp:'http://'+location.hostname,
};
if(location.hostname=='mykefang.com'){//测试环境
    Object.assign(config,{
        appName:'',
        resPre:'https://mykefang.com/file',
        skin:'teal',
        isDev:true,
        vaptchaId:'5de798b3e62d2b442088be96',//vaptcha的id
        officePre:'https://view.officeapps.live.com/op/view.aspx',
        resIp:'https://mykefang.com',
    });
}
export default config;
